import React from 'react';
import {withStyles} from '@material-ui/core/styles/index';
import classNames from 'classnames';
import {BROKER_NAME, BROKER_SHORT, BROKERID} from "../config";

const styles = theme => ({
    root: {},
    footText:{
        textAlign:"right",
        width:'100%'
    }
});

function MainFooter({classes})
{
    return (
        <div className={classNames(classes.root, "flex flex-1 text-right px-24")}>
            <div className={classes.footText}>{BROKER_NAME} ({BROKER_SHORT}:{BROKERID})</div>
            <div className={classes.footText}>&copy; Copyright 2019 Y Effect Pty Ltd</div>
        </div>
    );
}

export default withStyles(styles, {withTheme: true})(MainFooter);